import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { HelpActions, HelpSelectors } from 'src/app/store';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
})
export class HelpComponent {
    vm$ = this.store.select(HelpSelectors.selectHelpVM);
    constructor(private store: Store, private route: ActivatedRoute) {
        this.route.params.subscribe((params) => {
            if (params['id'])
                this.store.dispatch(
                    HelpActions.loadHelpDetails({ id: params['id'] })
                );
        });
    }
}
